import { CorePermissions, UserPermissions } from '@/constants/permissions.constant';
import { AllValues, ValuesOf } from './types.util';

export type CorePermissionValue = AllValues<typeof CorePermissions>;

export type PermissionName = AllValues<typeof UserPermissions>;
export type ZgriPermissionName = ValuesOf<typeof UserPermissions.Zgri>;

export type Permission = {
  id: string;
  permission_name: string;
  description: string;
  human_readable_name: string;
  active: boolean;
  viewable_in_landlord_portal: boolean;
  viewable_in_prosper: boolean;
  enabled: boolean;
  state: 'assigned' | 'unassigned' | 'not-set';
};

export enum PermissionKeyEnum {
  Core = 'core-permissions',
}
